export enum ERecordCommunicationType {
    CALL = 'call',
    WHATSAPP = 'whatsapp',
    EMAIL = 'email',
    LINKEDIN = 'linkedin',
    IN_PERSON = 'in_person',
    VIRTUAL_MEETING = 'virtual_meeting',
}

export enum EStageNoteType {
    GENERAL = 'general',
    RECOMMENDATION = 'recommendation',
    NEXT_STEPS = 'next_steps',
    MISCELLANEOUS = 'miscellaneous',
}
